import { connect } from 'react-redux';
import { onModalClosed, onModalOpened } from '../../../../actions/Analytics';
import ModalDialog from '../components/ModalDialog';
const mapDispatchToProps = dispatch => {
  return {
    onAnalyticsModalOpen: source => dispatch(onModalOpened(source)),
    onAnalyticsModalClose: source => dispatch(onModalClosed(source))
  };
};
export default connect(null, mapDispatchToProps)(ModalDialog);